<template>
  <div class="fs14">
    <el-table :data="data" border>
      <el-table-column
        v-for="(item) in colOptions"
        :key="item.prop"
        :prop="item.prop"
        :label="item.label"
        :minWidth="item.minWidth"
      >
        <template slot-scope="{ row }">
          <EditCell
            :data="row"
            :isEdit.sync="row.isEdit"
            v-bind="item"
            v-on="item.event"
            :options="typeof item.options === 'function' ? item.options(row) : item.options"
            disabled
          />
        </template>
      </el-table-column>
      <el-table-column v-if="!disabled" prop="operate" label="操作" width="180">
        <template slot-scope="{$index, row}">
          <div v-if="row.isEdit" class="fs20 bold">
            <i class="el-icon-check clickText mr20" @click="handleCheck(row)"></i>
            <i class="el-icon-close clickText" @click="handleCancel(row, $index)"></i>
          </div>
          <template v-else>
            <el-button class="p0" type="text" size="small" @click="handleEdit(row)">修改</el-button>
            <el-button class="p0" @click="handleDel(row)" type="text" size="small">删除</el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <i v-if="!disabled" class="el-icon-circle-plus-outline hoverText bold fs20 ml10" @click="handleAdd"></i>
  </div>
</template>
<script>
import EditCell from "@/components/EditCell.vue";
import { delLiveRoomAllocation, updateLiveRoomAllocation } from './api'
export default {
  components: { EditCell },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    disabled: Boolean,
    queue: Object,
    rooms: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    colOptions () {
      const inputNumberProps = {
      controls: false,
      placeholder: "请输入0~100",
      precision: 0,
      min: 0,
      max: 100,
    };
      return ([
        {
          label: "直播室",
          prop: "room_id",
          nameProp: "room_name",
          options: this.rooms,
          minWidth: 180,
          editType: "select",
          required: true,
          valueMap: "id",
          labelMap: "name",
          filterable: true,
          event: {
            change: (row) => {
              row.group_id = ''
            },
          }
        },
        {
          label: "分组",
          prop: "group_id",
          nameProp: "group_name",
          options: (row) => this.getGroupsByRoomId(row.room_id),
          minWidth: 100,
          editType: "select",
          required: true,
          valueMap: "group_id",
          filterable: true,
        },
        { label: "轮次数量", prop: "loop_times", editType: "input-number", required: true, ...inputNumberProps },
        { label: "排序权重", prop: "sort_weight", editType: "input-number", ...inputNumberProps },
      ])
    }
  },
  methods: {
    getGroupsByRoomId(roomId) {
      return this.rooms?.find((room) => room.id == roomId)?.groups?.map(item => {
        item.label = `${item.group_name}(${item.counts})`
        return item
      });
    },
    handleEdit(row) {
      this.tempRow = JSON.parse(JSON.stringify(row));
      this.$set(row, "isEdit", true);
    },
    async handleDel(row) {
      await this.$confirm("", "确认删除所选配置内容吗？");
      const { code } = await delLiveRoomAllocation({ id: row.id})
      if (code === 200) {
        this.$emit('update')
      }
    },
    async handleCheck(row) {
      for (let field of this.colOptions) {
        if (field.required && !row[field.prop] && row[field.prop] !== 0) {
          this.$message.error("请填入" + field.label);
          return;
        }
      }
      if (this.isCheckLoading) return 
      try {
        this.isCheckLoading = true
        const params = {
          queue_id: this.queue.queue_id,
          ...row,
        }
        delete params.isEdit
        const { code } = await updateLiveRoomAllocation(params)
        if (code === 200)
        this.$emit('update')
      } finally {
        this.isCheckLoading = false
      }
    },
    handleCancel(row, index) {
      if (row.id) {
        Object.keys(this.tempRow).forEach((key) => {
          row[key] = this.tempRow[key];
        });
        this.$set(row, "isEdit", false);
      } else {
        this.data.splice(index, 1);
      }
    },
    handleAdd() {
      this.data.push({
        isEdit: true,
        room_id: undefined,
        group_id: undefined,
        loop_times: undefined,
        sort_weight: undefined
      });
    },
  },
};
</script>
